/**
 * @generated SignedSource<<e57b9b0edd4b70ed6c720c83280f782a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutCheckWrapper_transaction$data = {
  readonly isNegotiable: boolean | null;
  readonly " $fragmentType": "CheckoutCheckWrapper_transaction";
};
export type CheckoutCheckWrapper_transaction$key = {
  readonly " $data"?: CheckoutCheckWrapper_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutCheckWrapper_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutCheckWrapper_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isNegotiable",
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "0fd34dd7ee5ac13fbc33aacc9cb38848";

export default node;
